import { formatApplicationSummary } from '../../formatters/formatApplicationSummary';
import { formatStringOrLoading } from '../../formatters/formatNumberToLocale';
import { RegistrationGlobalComponent } from 'types/components';
import { SectionData } from 'types';
import { useApplicationSummary } from '../../hooks/useApplicationSummary';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import RegistrationHeader, {
  RegistrationHeaderProps,
} from 'components/molecules/RegistrationHeader/RegistrationHeader';

export const Navbar: RegistrationGlobalComponent = ({
  hideEditButton = false,
  sectionID,
  sections,
  onCalculatorToggle,
  calculatorOpened,
  logoSquare,
  onBackBtnHandler,
  showTop = true,
}) => {
  const { t } = useTranslation();
  // TODO: calculate global progress instead (see Figma mobile design)
  const progress = sections
    ? (sections.findIndex((s: SectionData) => String(s.id) === sectionID) + 1) /
      sections.length
    : 0;

  const { amount, loading, term, repaymentDate } = formatApplicationSummary(
    useApplicationSummary(),
  );

  const data = useMemo(() => {
    const result: RegistrationHeaderProps['data'] = [
      {
        title: t('summary:amount'),
        type: 'money',
        unit: t('common:currencySymbol'),
        value: formatStringOrLoading(loading, amount, '###'),
      },
      {
        title: t('summary:duration'),
        type: 'days',
        unit: t('common:days'),
        value: formatStringOrLoading(loading, term, '##'),
      },
      {
        title: t('summary:repayment_date'),
        type: 'date',
        value: formatStringOrLoading(loading, repaymentDate, '##/##/####'),
      },
    ];
    return result;
  }, [amount, loading, repaymentDate, term]);

  return (
    <RegistrationHeader
      hideEditButton={hideEditButton}
      logo={logoSquare}
      onCalculatorToggle={onCalculatorToggle}
      calculatorOpened={calculatorOpened}
      data={data}
      loading={loading}
      progress={progress}
      onBackBtnHandler={onBackBtnHandler}
      showTop={showTop}
    />
  );
};
